import { setPatientHistory } from "./consultationSlice";
import { listPatientHistory } from "src/components/Dashboard/Patient/PatientDetail/api";

export const fetchPatientHistory = (patientId, start, end, status) => async (dispatch, getState) => {
    // const state = getState();
    // const existingAppointments = state?.consultation?.patientHistory[0]?.appointmentDetails;

    // if (existingAppointments && existingAppointments.patientId === patientId) return;

    try {
        const response = await listPatientHistory(patientId, start, end, status);
        if (response) {
            dispatch(setPatientHistory(response));
        } else {
            console.log("No patient data returned");
        }
    } catch (error) {
        console.error("Error fetching patient history: ", error);
    }

};

export const fetchAppointmentDetails = (appointmentId) => (dispatch, getState) => {
    const state = getState();
    const existingAppointments = state?.consultation?.patientHistory;

    if (!existingAppointments) return;

    const appointment = existingAppointments.find((appointment) => appointment.appointmentDetails.id === appointmentId);
    return appointment?.appointmentDetails;
};

export const fetchPatientDetails = (patientId) => (dispatch, getState) => {
    const state = getState();
    const existingPatientList = state?.patients?.patientList?.data;

    if (!existingPatientList) return;

    const patient = existingPatientList.find((patient) => patient.id === patientId);
    return patient;
};

export const selectPatientById = (state, patientId) => {
    const patientList = state?.patients?.patientList?.data;
    return patientList?.find((patient) => patient.id === patientId) || null;
};

export const selectAppointmentById = (state, appointmentId) => {
    const patientHistory = state?.consultation?.patientHistory;
    const appointment = patientHistory?.find(app =>
        app?.appointmentDetails?.id === appointmentId
    );
    return appointment?.appointmentDetails || null;
};